import {ItemTarefa} from "./lista-tarefa";

export class TarefasAgrupadasPorHora {
  itemHoras: ItemHora[] = [];
}

export class ItemHora{
  hora: string;
  tarefas: ItemTarefa[] = [];
}
